/* eslint-disable @typescript-eslint/naming-convention */
import type { IGlobalMask, IService } from '../../shared';
import { EventGenerator } from '../events';
import type { ServiceManager } from '../service-manager';

const __maskEventName = 'viewport:mask:1';

export class MaskService implements IService {
    constructor(readonly service: ServiceManager) {
        new EventGenerator('loading', this, service);
    }

    onInit() {
        this.setGlobalMask(null);
    }

    /** 全局遮罩 */
    readonly globalMask: IGlobalMask | null = null;
    declare getGlobalMask: () => IGlobalMask | null;
    declare setGlobalMask: (globalMask: IGlobalMask | null) => void;
    declare onGlobalMaskChange: (fn: (globalMask: IGlobalMask | null) => void) => number;

    /** 显示全局遮罩 */
    show(args: IGlobalMask) {
        this.setGlobalMask(args);
        this.__emitGlobalMask({
            isShow: true,
            isHide: false,
            zIndex: 1010,
            data: args,
        });
    }

    /** 隐藏全局遮罩 */
    hide() {
        this.setGlobalMask(null);
        this.__emitGlobalMask({
            isShow: false,
            isHide: true,
            zIndex: 0,
            data: null,
        });
    }

    /** 监听全局遮罩 */
    onMask(
        fn: (args: { isShow: boolean; isHide: boolean; zIndex: number; data: IGlobalMask | null }) => void,
        weight = 0,
    ) {
        return this.service.events.on(__maskEventName, fn, weight);
    }

    private __emitGlobalMask(args: { isShow: boolean; isHide: boolean; zIndex: number; data: IGlobalMask | null }) {
        this.service.events.emit(__maskEventName, args);
    }
}
